import { render, staticRenderFns } from "./waitChk.vue?vue&type=template&id=f1ba8e00&scoped=true"
import script from "./waitChk.vue?vue&type=script&lang=js"
export * from "./waitChk.vue?vue&type=script&lang=js"
import style0 from "./waitChk.vue?vue&type=style&index=0&id=f1ba8e00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ba8e00",
  null
  
)

export default component.exports